import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import ArrowLeftLineIcon from 'remixicon-react/ArrowLeftLineIcon';
import { useForm } from "react-hook-form";
import CardLayout from '../../components/utils/CardLayout'
import Button from '../../components/utils/Button'
import Table from '../../components/utils/Table';
import Papa from 'papaparse'
import Alert from '../../components/utils/Alert';

import activationRequestActions from '../../redux/activationRequest/actions';

const { validateSerialNumberForManualUpdate, updateManualPortinActivationForISP, resetMessage } = activationRequestActions;

const ManualActivationUpdate = ({ back, searchData }) => {
    const dispatch = useDispatch();
    const [fileName, setFileName] = useState([]);
    const [previewData, setPreviewData] = useState([]);
    const { validateSerialNumberForManualUpdateLoading, validateSerialNumberDataForManualUpdate, updateManualPortinActivationForISPLoading, updateManualPortinActivationForISPError, updateManualPortinActivationForISPMessage } = useSelector((state) => state.activationRequest);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');

    const {
        register: manualActivationUpdateRegister,
        handleSubmit: manualctivationUpdateHandleSubmit,
        formState: { errors: manualActivationUpdateError },
        watch: manualActivationUpdateWatch,
        reset: manualActivationUpdateReset,
        setValue: manualActivationUpdateSetValue,
        setError: manualActivationUpdateSetError,
        clearErrors: manualActivationUpdateClearErrors,
        control: manualActivationUpdatecontrol, } = useForm({
            defaultValues: {
            }
        });

    useEffect(() => {
        const statusData = validateSerialNumberDataForManualUpdate?.[1];
        if (Array.isArray(statusData) && statusData.length > 0) {
            const isValid = statusData.some(item => item.Status === 1);
            const isInvalid = statusData.some(item => item.Status === 0);

            if (isValid) {
                manualActivationUpdateSetError("uploadedFile", { type: "custom", message: '' });
            } else if (isInvalid) {
                setPreviewData([]);
                manualActivationUpdateSetError("uploadedFile", { type: "custom", message: statusData[0].Message, });
            } else {
                setPreviewData([]);
                manualActivationUpdateSetError("uploadedFile", { type: "custom", message: statusData[0].Message, });
            }
        }
    }, [validateSerialNumberDataForManualUpdate]);

    useEffect(() => {
        if (updateManualPortinActivationForISPMessage) {
            back();
            dispatch(resetMessage());
        }
    }, [updateManualPortinActivationForISPMessage]);

    useEffect(() => {
        if (updateManualPortinActivationForISPError !== null && updateManualPortinActivationForISPError !== undefined) {
            displayAlert(updateManualPortinActivationForISPError, 'alert-danger');
        }
    }, [updateManualPortinActivationForISPError]);

    const Uploadcolumns = [
        { displayName: '#', key: 'key' },
        { displayName: 'SERIAL NUMBER', key: 'ICCID' },
        { displayName: 'MOBILE NUMBER', key: 'PhoneNumber' },
        { displayName: 'ACCOUNT NUMBER', key: 'PortingAccountNumber' },
        { displayName: 'STATUS', key: 'ResponseStatus' },
    ]

    const handleFileChange = (e) => {
        const fileReader = new FileReader();
        let file = e.target.files[0];
        setPreviewData([]);
        setFileName("");
        manualActivationUpdateClearErrors("uploadedFile");
        if (!file) {
            manualActivationUpdateSetError("uploadedFile", { type: "custom", message: "Csv is required!", });
            return;
        }

        const fileNameWithExt = file.name;
        const fileName = fileNameWithExt.substring(0, fileNameWithExt.lastIndexOf('.')) || fileNameWithExt;
        setFileName(fileName);

        const fileExt = fileNameWithExt.split('.').pop().toLowerCase();
        if (fileExt !== "csv") {
            manualActivationUpdateSetError("uploadedFile", { type: "custom", message: "Invalid file type. Only CSV file allowed.", });
            return;
        }

        fileReader.onload = async ({ target }) => {
            const csvOutput = Papa.parse(target.result, { header: true, skipEmptyLines: true });
            const parsedData = csvOutput?.data;

            if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
                manualActivationUpdateSetError("uploadedFile", {
                    type: "custom",
                    message: "CSV file is empty!",
                });
                return;
            }
            const columns = Object.keys(parsedData[0]);

            const requiredHeaders = ['ICCID', 'Phone Number', 'Porting Account Number', 'Response Status'];
            const isValidCsvHeading = requiredHeaders.every((header) => columns.includes(header));

            if (isValidCsvHeading) {

                const hasValidRow = parsedData.some(row => Object.values(row).some(value => value && value.trim() !== ""));
                if (!hasValidRow) {
                    manualActivationUpdateSetError("uploadedFile", {
                        type: "custom",
                        message: "CSV file is empty!",
                    });
                    return;
                }
                const serialNumbers = parsedData.map((item) => item['ICCID']).filter((iccid) => iccid);
                if (serialNumbers.length > 0) {
                    dispatch(validateSerialNumberForManualUpdate(serialNumbers));
                }
                const mappedData = parsedData.map((item, index) => ({
                    key: index + 1,
                    ICCID: item['ICCID'],
                    PhoneNumber: item['Phone Number'],
                    PortingAccountNumber: item['Porting Account Number'],
                    ResponseStatus: item['Response Status'],
                }));
                setPreviewData(mappedData);
            } else {
                manualActivationUpdateSetError("uploadedFile", {
                    type: "custom", message: "Invalid Csv Selected",
                });
            }
        };
        fileReader.readAsText(file);
    };

    const handleAddManualActivationUpdate = (data) => {
        const validSerials = validateSerialNumberDataForManualUpdate?.[0]?.filter(item => item.RequestStatus === 49 || item.RequestStatus === 11)?.map(item => item.SerialNumber);
        const filteredReportData = previewData.filter(item => validSerials.includes(item.ICCID));
        if (filteredReportData.length === 0) {
            alert("No valid data to submit.");
            return;
        }
        else {
            const newData = {
                BatchID: fileName,
                BulkTransactionID: validateSerialNumberDataForManualUpdate?.[1]?.[0]?.BatchID,
                RequestSource: 1,
                ReportData: filteredReportData,
                ErrorDesc: ""
            };
            dispatch(updateManualPortinActivationForISP(newData, searchData));
        }
    };

    const handleClose = () => {
        manualActivationUpdateReset();
        setPreviewData([])
        dispatch(resetMessage());
        back()
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
    }

    return (
        <CardLayout title="Manual Activation Update For ISP">
            <div className="row mb-3">
                <div className='col-lg-12 text-right'>
                    <button
                        type="button"
                        onClick={() => {
                            manualActivationUpdateReset();
                            setPreviewData([]);
                            manualActivationUpdateClearErrors();
                            dispatch(resetMessage());
                            back();
                        }}
                        className={`btn btn-danger font-weight-bold`} > <ArrowLeftLineIcon size={16} />Back </button>

                </div>
            </div>
            <div className='container'>

                <form onSubmit={manualctivationUpdateHandleSubmit(handleAddManualActivationUpdate)}>
                    <div className="col-md-6 mb-3">
                        <div className="input-group">
                            <label htmlFor="csvFile"><span className='text-danger'>*</span>Upload File </label>
                            <input
                                type="file"
                                className="form-control-file"
                                name='uploadedFile'
                                id="csvFile"
                                accept='.csv'
                                {...manualActivationUpdateRegister('uploadedFile', { required: 'Csv is required' })}
                                onChange={(e) => handleFileChange(e)}
                            />
                            {manualActivationUpdateError && manualActivationUpdateError.uploadedFile && (<div className="invalid-feedback">{manualActivationUpdateError.uploadedFile.message}</div>)}

                        </div>

                    </div>
                    {validateSerialNumberDataForManualUpdate?.[1]?.[0]?.Status === 1 && (
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-center">
                                <span className="mb-0 me-2 fw-bold" style={{ fontWeight: '700', color: 'black', fontSize: '18px' }}>Batch Transaction ID:</span>
                                <span className="fw-bold text-center" style={{ marginLeft: '5px', fontWeight: '500' }}>
                                    {validateSerialNumberDataForManualUpdate?.[1]?.[0]?.BatchID}
                                </span>
                            </div>
                        </div>
                    )}

                    {showAlert && updateManualPortinActivationForISPError && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
                    {previewData.length > 0 && (
                        <Table columns={Uploadcolumns} data={previewData} loading={validateSerialNumberForManualUpdateLoading} pagination={false} />)}
                    <div className='text-right row mt-2'>
                        <div className="col-md-12">
                            {previewData.length > 0 && (
                                <div>
                                    <button type="button" className="btn btn-secondary mr-2" onClick={handleClose}>Close</button>
                                    <Button title="Submit" style="minWidth:80px" loading={updateManualPortinActivationForISPLoading} buttonClass="btn btn-primary" buttonType="submit" />
                                </div>
                            )}
                        </div>
                    </div>
                </form>
            </div>

        </CardLayout>
    )
}

export default ManualActivationUpdate
